module.exports = __webpack_public_path__ + "static/media/icono_gluten.90dd035c.png";